export default __webpack_public_path__ + "static/icon-19-5-2a655b350d6bfd1913d8ccec98ef496c.png";